export const colors = {
  primary:
    'border-neutral-50 hover:border-base-primary ' +
    'focus:border-primary-700 focus:ring-primary-50 focus:shadow-primary',

  secondary:
    'border-neutral-50 hover:border-base-primary ' +
    'focus:border-secondary-accent focus:ring-secondary-50 focus:shadow-secondary',

  neutral:
    'border-neutral-50 hover:border-base-primary ' +
    'focus:border-base-primary focus:ring-neutral-200 focus:shadow-sm',

  warning:
    'border-warning-400 hover:border-warning-400 ' +
    'focus:border-warning-400 focus:ring-warning-200 focus:shadow-warning',

  error:
    'border-secondary-accent hover:border-secondary-accent ' +
    'focus:border-secondary-accent focus:ring-secondary-50 focus:shadow-secondary',
} as const;
